<template>
  <b-modal class="modal-lg" v-if="getModalLevel('info') == 'main'" id="infoModal" ref="info-modal" :title="docInfoModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="resetModal('main')">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'info']" size="1x" class="mr-2"/> {{ docInfoModal.modalData.title }}</h5>
      <button ref="button-close-info" aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <table v-if="docInfoModal.docuData" class="table info-table">
        <tr>
          <td class="text-white">{{ t('labelId','labelId') }}</td>
          <td>{{ docInfoModal.docuData.id }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelDocumentPrincipal','labelDocumentPrincipal') }}</td>
          <td>{{ (docInfoModal.docuData.movianto_principle) ? docInfoModal.docuData.movianto_principle : '' }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelDataTransfer','labelDataTransfer') }}</td>
          <td>{{ (docInfoModal.docuData.dont_dataxfer == 0) ? t('labelYes','labelYes') : t('labelNo','labelNo') }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelEmail','labelEmail') }}</td>
          <td>{{ (docInfoModal.docuData.dont_email == 0) ? t('labelYes','labelYes') : t('labelNo','labelNo') }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelFax','labelFax') }}</td>
          <td>{{ (docInfoModal.docuData.dont_fax == 0) ? t('labelYes','labelYes') : t('labelNo','labelNo') }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelPost','labelPost') }}</td>
          <td>{{ (docInfoModal.docuData.dont_post == 0) ? t('labelYes','labelYes') : t('labelNo','labelNo') }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelHidden','labelHidden') }}</td>
          <td>{{ docInfoModal.docuData.is_hidden }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelReadStatus','labelReadStatus') }}</td>
          <td>{{ docInfoModal.docuData.is_read }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelToBeDeleted','labelToBeDeleted') }}</td>
          <td>{{ docInfoModal.docuData.to_be_deleted }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelStatus','labelStatus') }}</td>
          <td>{{ docInfoModal.docuData.doc_status }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelClientData1','labelClientData1') }}</td>
          <td>{{ this.clientDataName1 }} : {{ docInfoModal.docuData.client_data_1 }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelClientData2','labelClientData2') }}</td>
          <td>{{ this.clientDataName2 }} : {{ docInfoModal.docuData.client_data_2 }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelCurrency','labelCurrency') }}</td>
          <td>{{ docInfoModal.docuData.currency }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelPaymentStatus','labelPaymentStatus') }}</td>
          <td>{{ docInfoModal.docuData.payment_status }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelAccepted','labelAccepted') }}</td>
          <td>{{ (docInfoModal.docuData.accepted == 1) ? t('labelYes','labelYes') : t('labelNo','labelNo') }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelDigitallySigned','labelDigitallySigned') }}</td>
          <td>{{ docInfoModal.docuData.digitally_signed }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelBusinessUnit','labelBusinessUnit') }}</td>
          <td>{{ docInfoModal.docuData.business_unit }}</td>
        </tr>
      </table>
      <div v-if="docInfoModal.docuData.post_house || docInfoModal.docuData.post_code">
        <h5 class="text-center py-2">{{ t('docInfoModalPosting','docInfoModalPosting') }}</h5>
        <table class="table info-table">
          <tr>
            <td class="text-white">{{ t('labelPostHouse','labelPostHouse') }}</td>
            <td if="docInfoModal.docuData.post_house">{{docInfoModal.docuData.post_house}}</td>
          </tr>
          <tr>
            <td class="text-white">{{ t('labelCountry','labelCountry') }}</td>
            <td if="docInfoModal.docuData.country">{{docInfoModal.docuData.country}}</td>
          </tr>
          <tr>
            <td class="text-white">{{ t('labelPostCode','labelPostCode') }} / {{ t('labelZipCode','labelZipCode') }}</td>
            <td if="docInfoModal.docuData.post_code">{{docInfoModal.docuData.post_code}}</td>
          </tr>
        </table>
      </div>
    </template>
  </b-modal>
  <b-modal class="modal-lg" v-else id="subInfoModal" ref="subinfo-modal" :title="docInfoModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="resetModal('sub', thisButton)">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'info']" size="1x" class="mr-2"/> {{ docInfoModal.modalData.title }}</h5>
      <button ref="button-close-info" aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <table v-if="docInfoModal.docuData" class="table info-table">
        <tr>
          <td class="text-white">{{ t('labelId','labelId') }}</td>
          <td>{{ docInfoModal.docuData.id }}</td>
        </tr>
        <tr v-if="docInfoModal.docuData.movianto_principle">
          <td class="text-white">{{ t('labelDocumentPrincipal','labelDocumentPrincipal') }}</td>
          <td>{{ docInfoModal.docuData.movianto_principle }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelDataTransfer','labelDataTransfer') }}</td>
          <td>{{ (docInfoModal.docuData.dont_dataxfer == 0) ? t('labelYes','labelYes') : t('labelNo','labelNo') }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelEmail','labelEmail') }}</td>
          <td>{{ (docInfoModal.docuData.dont_email == 0) ? t('labelYes','labelYes') : t('labelNo','labelNo') }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelFax','labelFax') }}</td>
          <td>{{ (docInfoModal.docuData.dont_fax == 0) ? t('labelYes','labelYes') : t('labelNo','labelNo') }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelPost','labelPost') }}</td>
          <td>{{ (docInfoModal.docuData.dont_post == 0) ? t('labelYes','labelYes') : t('labelNo','labelNo') }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelHidden','labelHidden') }}</td>
          <td>{{ docInfoModal.docuData.is_hidden }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelReadStatus','labelReadStatus') }}</td>
          <td>{{ docInfoModal.docuData.is_read }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelToBeDeleted','labelToBeDeleted') }}</td>
          <td>{{ docInfoModal.docuData.to_be_deleted }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelStatus','labelStatus') }}</td>
          <td>{{ docInfoModal.docuData.doc_status }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelClientData1','labelClientData1') }}</td>
          <td>{{ this.clientDataName1 }} : {{ docInfoModal.docuData.client_data_1 }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelClientData2','labelClientData2') }}</td>
          <td>{{ this.clientDataName2 }} : {{ docInfoModal.docuData.client_data_2 }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelCurrency','labelCurrency') }}</td>
          <td>{{ docInfoModal.docuData.currency }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelPaymentStatus','labelPaymentStatus') }}</td>
          <td>{{ docInfoModal.docuData.payment_status }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelAccepted','labelAccepted') }}</td>
          <td>{{ (docInfoModal.docuData.accepted == 1) ? t('labelYes','labelYes') : t('labelNo','labelNo') }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelDigitallySigned','labelDigitallySigned') }}</td>
          <td>{{ docInfoModal.docuData.digitally_signed }}</td>
        </tr>
        <tr>
          <td class="text-white">{{ t('labelBusinessUnit','labelBusinessUnit') }}</td>
          <td>{{ docInfoModal.docuData.business_unit }}</td>
        </tr>
      </table>
      <div v-if="docInfoModal.docuData.post_house || docInfoModal.docuData.post_code">
        <h5 class="text-center py-2">{{ t('docInfoModalPosting','docInfoModalPosting') }}</h5>
        <table class="table info-table">
          <tr>
            <td class="text-white">{{ t('labelPostHouse','labelPostHouse') }}</td>
            <td if="docInfoModal.docuData.post_house">{{docInfoModal.docuData.post_house}}</td>
          </tr>
          <tr>
            <td class="text-white">{{ t('labelCountry','labelCountry') }}</td>
            <td if="docInfoModal.docuData.country">{{docInfoModal.docuData.country}}</td>
          </tr>
          <tr>
            <td class="text-white">{{ t('labelPostCode','labelPostCode') }} / {{ t('labelZipCode','labelZipCode') }}</td>
            <td if="docInfoModal.docuData.post_code">{{docInfoModal.docuData.post_code}}</td>
          </tr>
        </table>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'
import Loading from 'vue-loading-overlay'

export default {
  name: 'ModalInfoDoc',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal',
    'getModalLevel'
  ],
  data () {
    return {
      //docInfoModal: {},
      buttonIsBusy: false
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    thisButton() {
      return this.$refs['button-close-info']
    },
    clientDataName1() {
      return this.$store.getters.allTemplateDetails.client_data_1_name
    },
    clientDataName2() {
      return this.$store.getters.allTemplateDetails.client_data_2_name
    },
    docInfoModal:{
      get:function(){
        return this.$attrs.modal
      },
      set:function(d){
        this.docInfoModal = d
      },
    }
  },
  methods:{
  },
  created() {
    //this.docInfoModal = this.$attrs.modal
  },
  filters:{
    humanReadable: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  },
  components:{
    ResponseInfo,
    Loading
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
/*main modal level*/
.modal-open #infoModal___BV_modal_outer_ >>> .modal-content{
  min-width: 700px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #infoModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 450px;
  overflow-y: scroll;
}
/*sub modal level*/
.modal-open #subInfoModal___BV_modal_outer_ >>> .modal-content{
  min-width: 700px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #subInfoModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 450px;
  overflow-y: scroll;
}

.info-table tr td:nth-of-type(1){
  background-color: #34495e;
  width: 200px;
}
</style>
